module.exports = __webpack_public_path__ + "img/go8.8bebbc3a.png";